<template>
	<div>
		<span>{{placeHold}}</span>
		<input type="text" class="topcoat-text-input"
		       v-validate="vali"
		       data-vv-name="text"
		       :class="{'is-danger': errors.has('text') }"
		       :placeholder="placeHold"
		       v-model.trim="value">
		<span v-show="errors.has('text')"
		      class="help is-danger">X</span>
	</div>
	<!--<div class="control column is-2">-->
	<!--<label class="label">{{placeHold}}</label>-->
	<!--<input v-validate="vali"-->
	<!--data-vv-name="text"-->
	<!--class="input"-->
	<!--:class="{'is-danger': errors.has('text') }"-->
	<!--type="text"-->
	<!--:placeholder="placeHold"-->
	<!--v-model.trim="value">-->

	<!--<p v-show="errors.has('text')"-->
	<!--class="help is-danger">-->
	<!--{{ errors.first('text') }}-->
	<!--</p>-->
	<!--</div>-->
</template>

<script>
	import randWord from 'random-lorem'
	export default {
		data () {
			return {
				placeHold: '',
				value: '',
				vali: {rules: {required: true, in: []}}
			}
		},
		methods: {
			randomWords () {
				return randWord({min: 2, max: 12});
			}
		},
		created() {
			const randWord = this.randomWords()
			this.placeHold = randWord
			this.vali.rules.in[0] = randWord
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	label {
		padding: 0 10px;
	}
	input[type=text].is-danger {
		border-color: #ff3860;
	}
</style>



// WEBPACK FOOTER //
// TextInput.vue?2d8c6c80